//
export default [
    {
        name    : 'rut',
        props   : {
            hideDetails : true,
            label       : 'RUT',
        },
        type    : 'text',
        value   : '',
    },
    {
        name    : 'business_name',
        props   : {
            hideDetails : true,
            label       : 'Razón social',
        },
        type    : 'text',
        value   : '',
    },
    {
        name    : 'alias_name',
        props: {
            hideDetails : true,
            label       : 'Alias',
        },
        type    : 'text',
        value   : '',
    },
    {
        name    : 'core_business',
        props   : {
            hideDetails : true,
            label       : 'Nombre de negocio',
        },
        type    : 'text',
        value   : '',
    },
    {
        name    : 'blocked_sales',
        props: {
            clearable   : true,
            hideDetails : true,
            items: [
                {
                    text    : 'Si',
                    value   : 'true',
                },
                {
                    text    : 'No',
                    value   : 'false',
                },
            ],
            label       : 'Tiendas bloqueadas',
            singleLine  : false,
        },
        noPrepend   : true,
        type        : 'select',
        value       : '',
    },
    {
        name    : 'is_available_ground_seller',
        props: {
            clearable   : true,
            hideDetails : true,
            items: [
                {
                    text    : 'Si',
                    value   : 'true',
                },
                {
                    text    : 'No',
                    value   : 'false',
                },
            ],
            label       : 'Tiendas habilitado un vendedor en terreno',
            singleLine  : false,
        },
        noPrepend   : true,
        type        : 'select',
        value       : '',
    },
]